import { useEffect, useState } from "react";
import { ShieldCheck, FileSpreadsheet } from "lucide-react";
import api from "@/lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export function CustomerConsents({ customerId }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.customerConsents(customerId).then(setRows).catch(() => setRows([])); }, [customerId]);
  return (
    <div data-testid="customer-consents">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold flex items-center gap-1.5"><ShieldCheck className="h-4 w-4 text-emerald-400" /> Consensi (GDPR)</h3>
        <a href={api.customerConsentsExportUrl(customerId)} className="inline-flex items-center gap-1 h-7 px-2 rounded-md text-xs border border-border hover:bg-secondary/60" data-testid="customer-consents-export"><FileSpreadsheet className="h-3.5 w-3.5" /> Excel</a>
      </div>
      {!rows ? <p className="text-xs text-muted-foreground">Caricamento…</p> : rows.length === 0 ? <p className="text-xs text-muted-foreground">Nessun consenso registrato</p> : (
        <div className="overflow-auto max-h-56 rounded-lg border border-border">
          <table className="w-full text-xs">
            <thead className="bg-secondary/60 text-left sticky top-0"><tr><th className="px-2 py-1.5">Data</th><th className="px-2 py-1.5">Tipo</th><th className="px-2 py-1.5">Concorso</th><th className="px-2 py-1.5">Reg.</th><th className="px-2 py-1.5">Privacy</th><th className="px-2 py-1.5">Rif.</th></tr></thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={`${r.data}-${r.tipo}-${i}`} className="border-t border-border/60" data-testid={`customer-consent-row-${i}`}>
                  <td className="px-2 py-1.5 whitespace-nowrap font-mono-code text-muted-foreground">{fmt(r.data)}</td>
                  <td className="px-2 py-1.5">{r.tipo}</td>
                  <td className="px-2 py-1.5 truncate max-w-[140px]">{r.concorso}</td>
                  <td className="px-2 py-1.5 font-mono-code">{r.versione_regolamento !== "" ? `v${r.versione_regolamento}` : "—"}</td>
                  <td className="px-2 py-1.5 font-mono-code">{r.versione_privacy !== "" && r.versione_privacy != null ? `v${r.versione_privacy}` : "—"}</td>
                  <td className="px-2 py-1.5 text-muted-foreground truncate max-w-[160px]">{r.riferimento}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
